import React from "react";

import Edit from "../Lessons/LessonEdit";

class SelfDevelopmentEdit extends React.Component {

    render() {
        return <>
            <Edit match={this.props.match}
                type="SelfDevelopment"
                typeTreeView="SelfDevelopment" />
        </>;
    }
}

export default SelfDevelopmentEdit;